import store from "../views/store/index.vue";
import store_create from "../views/store/create.vue";
import store_edit from "../views/store/edit.vue";
import store_detail from "../views/store/detail.vue";
import store_import from "../views/store/import.vue";

const routes = [
  {
    path: "/store",
    name: "store",
    component: store,
    meta: { authOnly: true }
  },
  {
    path: "/store/create",
    name: "store_create",
    component: store_create,
    meta: { authOnly: true }
  },
  {
    path: "/store/edit/:uuid",
    name: "store_edit",
    component: store_edit,
    meta: { authOnly: true }
  },
  {
    path: "/store/detail/:uuid",
    name: "store_detail",
    component: store_detail,
    meta: { authOnly: true }
  },
  {
    path: "/store/import",
    name: "store_import",
    component: store_import,
    meta: { authOnly: true }
  }
];

export default routes;
